// extracted by mini-css-extract-plugin
export default {"avatar":"IonItemIcon_avatar__nmcQv","icon":"IonItemIcon_icon__VKFje"};